export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[700px] mx-auto text-center bg-background-100 rounded-lg border border-background-200/60 p-8 md:p-10">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-smartphone-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">移动吃瓜</h2>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6">
            爆料网移动版已全面适配主流手机浏览器，随时随地追最新网红八卦黑料。
            打开手机浏览器访问本站即可自动适配移动端布局，专属App正在开发中，敬请期待！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="#" className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-md text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-android-line"></i> Android 版
            </a>
            <a href="#" className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-md text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-apple-line"></i> iOS 版
            </a>
          </div>
          <p className="text-xs text-foreground-400 mt-4">即将上线，敬请期待</p>
        </div>
      </div>
    </section>
  );
}